import PropTypes from 'prop-types';
import React from 'react';
import slugify from '../../helpers/slugify';

import Assets from '../../helpers/Assets';
import BraintreeCardPayment from '../../records/order/BraintreeCardPayment';

function BraintreePaymentCardDetails ({
    highDefinition,
    payment: card,
    mask
}) {
    const { cardPan: pan } = card;
    const cardType = card.cardType || '';

    const cardTypeSlug = slugify(cardType.toLowerCase());

    const highDefImageArt = (<img className="pan-hd__image" src={ Assets.assetUrl(`images/card-hd-${cardTypeSlug}.png`) } alt={ cardType }/>);
    let cardNumber;

    if (mask) {
        cardNumber = pan && `**** **** **** ${ pan.substring(pan.length - 4) }`;
    } else {
        cardNumber = pan && pan.split(/(....)/).join(' ').trim();
    }

    return highDefinition ? (
        <div>
            { highDefImageArt }
            <div className="pan-hd__details">
                {cardNumber}
            </div>
        </div>
    ) : (
        <div>
            {cardNumber}
        </div>
    );
}

BraintreePaymentCardDetails.propTypes = {
    highDefinition: PropTypes.bool,
    payment: PropTypes.instanceOf(BraintreeCardPayment).isRequired,
    mask: PropTypes.bool
};

BraintreePaymentCardDetails.defaultProps = {
    highDefinition: true,
    mask: true,
};

export default BraintreePaymentCardDetails;
